// import Swiper bundle with all modules installed
// import Swiper from "swiper/bundle";
import Swiper from "swiper";
import { Scrollbar, Mousewheel } from "swiper/modules";

// import styles bundle
import "swiper/css/bundle";

// init Swiper:
export default function () {
    const swiper = new Swiper(".mySwiper", {
        modules: [Scrollbar, Mousewheel],
        direction: "horizontal",
        mousewheel: true,
        slidesPerView: 1.17,
        spaceBetween: 30,
        slidesPerGroup: 1,
        loop: false,
        observer: true,
        observeParents: true,
        lazy: true,
        lazyPreloadPrevNext: 4,
        scrollbar: {
            el: ".swiper-scrollbar",
            hide: false,
            draggable: true,
            dragSize: 100,
        },
        breakpoints: {
            600: {
                slidesPerView: 2.4,
            },
            1100: {
                slidesPerView: 4.25,
            },
            1500: {
                slidesPerView: 5.35,
            },
        },
    });
}
